import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import ReactivateMembershipOptionBody from './components/ReactivateMembershipOptionBody';
import { Homeless, ReliveOptions } from 'types';
import { deploymentSelectorCopy } from 'util/membershipHelper';

type ReactivateMembershipOptionProps = {
    member: Homeless;
    deploymentName?: string | null;
    reliveOptions: ReliveOptions;
    currentDeployment: {
        canSignUp?: boolean;
        shortReasoning?: string | null;
    } | null;
    otherDeployments: Array<{
        canSignUp?: boolean;
        shortReasoning?: string | null;
    }>;
    onClose: () => void;
    onSelectOption: (sameDeployment: boolean) => void;
};

const ReactivateMembershipOption: React.FC<ReactivateMembershipOptionProps> = ({
    member,
    deploymentName,
    reliveOptions,
    currentDeployment,
    otherDeployments,
    onClose,
    onSelectOption
}) => {
    const memberName = member.pii_first_name || member.first_name || member.name;
    const copy = deploymentSelectorCopy({
        memberName,
        deploymentName,
        reliveOptions,
        currentDeployment,
        otherDeployments,
        membershipExtension: Boolean(member.membership_extension)
    });

    return (
        <Modal2 onClose={onClose} title={copy.title}>
            <ReactivateMembershipOptionBody
                mobile_photo={member.photo}
                title={copy.title}
                subtext={copy.subtext}
                option1Text={copy.yesText}
                option2Text={copy.noText}
                onSelectOption={onSelectOption}
            />
        </Modal2>
    );
};

export default ReactivateMembershipOption;
